module.exports = __webpack_public_path__ + "static/stockbg-da18e5cea3fb269cfd228f83fa26ba5b.jpg";